import { render, staticRenderFns } from "./ProviderMaterialsModal.vue?vue&type=template&id=c3db190a&scoped=true"
import script from "./ProviderMaterialsModal.vue?vue&type=script&lang=js"
export * from "./ProviderMaterialsModal.vue?vue&type=script&lang=js"
import style0 from "./ProviderMaterialsModal.vue?vue&type=style&index=0&id=c3db190a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3db190a",
  null
  
)

export default component.exports